<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button default-href="/"></ion-back-button>
        </ion-buttons>
        <ion-title>Follow Up</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <ion-toolbar>
        <ion-segment :value="current_segment" @ionChange="segmentChanged($event)">
          <ion-segment-button value="search">
            Search
          </ion-segment-button>
          <ion-segment-button value="history">
            History
          </ion-segment-button>
        </ion-segment>
      </ion-toolbar>
      <ion-card v-if="current_segment==='search'"> 
        <ion-card-header>
          <ion-card-subtitle>Find the status of your issue</ion-card-subtitle>
          <ion-card-title>Follow Up</ion-card-title>
        </ion-card-header>

        <ion-card-content>
          <form>
                <ion-item id="rounded" lines="none">
                    <ion-label position="floating">Issue reference</ion-label>
                    <ion-input name="reference" v-validate="'required'" :value="search_ref" @ionInput="search_ref=$event.target.value"></ion-input>
                </ion-item>
                <p class="error" :force-show="errors.has('reference')">{{ errors.first('reference') }}</p>
                <ion-button ref="searchBtn" @click="processFetch" expand="full">Find Issue</ion-button>
            </form>
        </ion-card-content>
      </ion-card>
        
      <ion-card v-if="issue.reference&&current_segment==='search'">
        <ion-card-header>
          <ion-card-subtitle>Issue Reference: {{issue.reference}}</ion-card-subtitle>
          <ion-card-title>Status: {{issue.status}}</ion-card-title>
        </ion-card-header>

        <ion-card-content>
          {{issue.status_details}}
        </ion-card-content>
      </ion-card>
      <ion-list v-if="current_segment==='history'">
            <ion-item v-for="iss in issue_history" :key="iss.id" @click="issueClicked(iss)">
              <ion-avatar slot="start">
                  <img src="../assets/hosp_icon.png">
              </ion-avatar>
              <ion-label>
                  <h2>{{iss.reference}}</h2>
                  <h3>Priority: {{iss.priority}}</h3>
                  <p>Category: {{iss.category}}</p>
              </ion-label>
            </ion-item>
        </ion-list>
    </ion-content>
  </ion-page>
</template>

<script>
export default {
    name:'followup',
    data(){
      return {
        issue:{},
        search_ref:null,
        current_segment:'search',
        issue_history:null
      }
    },
    methods:{
      fetchIssue(){
        const base_url=this.$store.get('base_url');
        this.$http.get(base_url+'/api/issues/'+encodeURIComponent(this.search_ref))
        .then((res)=>this.issue=res.data)
        .catch((err)=>console.log(err));
      },
      fetchHistory(){
        this.issue_history=this.$store.get('issue_history');
      },
      issueClicked(selected){
        //show reference and fetch
        this.search_ref=selected.reference;
        this.current_segment='search';
      },
      processFetch(){
        this.$validator.validateAll().then((res)=>res && this.fetchIssue());
      },
      segmentChanged(ev){
        this.current_segment=ev.detail.value;
      }
    },
    created(){
      this.fetchHistory();
    }
}
</script>

<style scoped>
ion-toolbar {
  --ion-toolbar-background:#fbc414;
  --ion-text-color:white;
}
ion-segment{
  --ion-color-primary:white;
}
ion-back-button{
    --color:white;
}
ion-button{
    --background:#1b9346;
}
#rounded{
    --border-color: #d2d2d2;
  --border-radius: 10px;
  --border-width: 1px;
  --box-shadow: 2px gray;
  --highlight-height: 0;
  --background: #f8f9fa;
  margin: 10px;
  margin-right: 0px;
  margin-left: 0px;
}
.error{
  padding-left: 10px;
  text-transform: uppercase;
  color: red;
  font-size: 0.7em;
}
</style>